import clsx from 'clsx';

import type { PaidBreakExceptionVariant, PaidBreakRequestStatus } from '#/shared/types/PaidBreakRequest';

type PaidBreakExceptionContainerProps = {
  status: PaidBreakRequestStatus;
  variant: PaidBreakExceptionVariant;
  children: React.ReactNode;
  ariaDescribedBy?: string;
  ariaInvalid?: boolean | 'true' | 'false';
};

const getStatusStyles = (status: PaidBreakRequestStatus, variant: PaidBreakExceptionVariant) => {
  if (variant === 'summary') {
    return {
      container: 'rounded-xs border-1 border-primary-tint bg-primary-surface-l1',
    };
  }

  switch (status) {
    case 'pending':
      return {
        container: 'rounded-xs border-1 border-warning bg-warning-surface-l1',
      };
    case 'accepted':
      return {
        container: 'rounded-xs border-1 border-success bg-success-surface-l1',
      };
    case 'rejected':
      return {
        container: 'rounded-xs border-1 border-primary-shade bg-surface-l2',
      };
    case 'error':
      return {
        container: 'rounded-xs border-1 border-error bg-error-surface-l1',
      };
    default:
      return {
        container: 'rounded-xs border-1 border-warning bg-warning-surface-l1',
      };
  }
};

export function PaidBreakExceptionContainer({
  status,
  variant,
  children,
  ariaDescribedBy,
  ariaInvalid,
}: PaidBreakExceptionContainerProps) {
  const statusStyles = getStatusStyles(status, variant);

  return (
    <div
      className={clsx('p-16', statusStyles.container)}
      aria-describedby={ariaDescribedBy}
      aria-invalid={ariaInvalid}
      role={variant === 'individual' ? 'group' : undefined}
      aria-label={variant === 'individual' ? 'Paid break exception request' : undefined}
    >
      {children}
    </div>
  );
}
